import defaultSettings from '@/settings'

import i18n from '@/languages'

const title = defaultSettings.title || '龙翼客车运营管理平台'

export default function getPageTitle(key) {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${title}`
  }

  // if (pageTitle) {
  //   return `${pageTitle} - ${title}`
  // }
 
  return `${title}`
}
